import Vue from 'vue';
import store from '@/store';
import * as types from './mutation-types';
import RmsDamdangProxy from "../../../proxies/RmsDamdangProxy";

export const getList = ({ commit}) => {
 
  new RmsDamdangProxy()
    .all()
    .then((response) => {
      commit(types.LIST, response.items);
    })
};

/**
 * 등록
 * @param commit
 * @param param
 */
 export const create = ({ commit }, param) => {
  return new RmsDamdangProxy()
    .create(param)
};

export const update = ({ commit }, param) => {
  return new RmsDamdangProxy()
    .update(param.id, param)
};

export const destroy = ({ commit }, id) => {
  return new RmsDamdangProxy()
    .destroy(id)
};

export default {
  getList,
  create,
  update,
  destroy
}